import { CONNECTED } from 'lib/utils/facebookStatuses';
import { config, msg } from 'api';
import { setSuccessMessage, setErrorMessage } from 'apps/notifications/actions/notifications';
import errorHandler from 'lib/utils/errorHandler';
import { pageEventTypes, wa } from 'apps/analytics';

export const FACEBOOK_LINKED_FIELD_NAME = 'FACEBOOK_LINKED';

export const CLOSE_FACEBOOK_ACCOUNT_ALREADY_LINKED_POPUP = 'CLOSE_FACEBOOK_ACCOUNT_ALREADY_LINKED_POPUP';
export const OPEN_FACEBOOK_ACCOUNT_ALREADY_LINKED_POPUP = 'OPEN_FACEBOOK_ACCOUNT_ALREADY_LINKED_POPUP';
export const CLOSE_FACEBOOK_LOGIN_NOT_POSSIBLE_ERROR_POPUP = 'CLOSE_FACEBOOK_LOGIN_NOT_POSSIBLE_ERROR_POPUP';
export const OPEN_FACEBOOK_LOGIN_NOT_POSSIBLE_ERROR_POPUP = 'OPEN_FACEBOOK_LOGIN_NOT_POSSIBLE_ERROR_POPUP';
export const SET_FACEBOOK = 'SET_FACEBOOK';

export function setFacebook(facebookId, linked) {
  return {
    type: SET_FACEBOOK,
    facebookId,
    linked,
  };
}

export function getFacebook() {
  return (dispatch, getState, { network }) =>
    network.get(`${config.apiBasePath}/settings/facebook`)
      .then(response =>
        dispatch(setFacebook(response.facebookId, response.linked)),
      )
      .catch(errorHandler);
}

export function openAccountAlreadyLinkedPopup() {
  return { type: OPEN_FACEBOOK_ACCOUNT_ALREADY_LINKED_POPUP };
}

export function closeAccountAlreadyLinkedPopup() {
  wa.triggerPageEvent(pageEventTypes.FACEBOOK_SETTINGS_ALREADY_LINKED_POPUP_CLOSED, {});
  return { type: CLOSE_FACEBOOK_ACCOUNT_ALREADY_LINKED_POPUP };
}

export function confirmAccountAlreadyLinkedPopup() {
  return { type: CLOSE_FACEBOOK_ACCOUNT_ALREADY_LINKED_POPUP };
}

export function closeLoginNotPossiblePopup() {
  return { type: CLOSE_FACEBOOK_LOGIN_NOT_POSSIBLE_ERROR_POPUP };
}

export function confirmLoginNotPossiblePopup() {
  wa.triggerPageEvent(pageEventTypes.FACEBOOK_SETTINGS_NO_PASSWORD_POPUP_CONFIRMED, {});
  return (dispatch, getState, { network }) => {
    dispatch(closeLoginNotPossiblePopup());
    return network.redirectTo({ to: '/webshop/editLoginDetails.go' });
  };
}

export function openFacebookLoginNotPossiblePopup() {
  return { type: OPEN_FACEBOOK_LOGIN_NOT_POSSIBLE_ERROR_POPUP };
}

export function unlinkFacebook() {
  return (dispatch, getState, { network }) =>
    network.del(`${config.apiBasePath}/settings/facebook`)
      .then(() => {
        wa.triggerPageEvent(
          pageEventTypes.FACEBOOK_SETTINGS_SUCCESS_NOTIFICATION_DISPLAYED, { [FACEBOOK_LINKED_FIELD_NAME]: false }
        );
        dispatch(setSuccessMessage('Facebook account unlinked'));
        return dispatch(getFacebook());
      })
      .catch((error) => {
        if (error.data.status === 'LOGIN_NOT_POSSIBLE') {
          wa.triggerPageEvent(pageEventTypes.FACEBOOK_SETTINGS_NO_PASSWORD_POPUP_DISPLAYED, {});
          return dispatch(openFacebookLoginNotPossiblePopup());
        }
        wa.triggerPageEvent(
          pageEventTypes.FACEBOOK_SETTINGS_ERROR_NOTIFICATION_DISPLAYED, { [FACEBOOK_LINKED_FIELD_NAME]: false }
        );
        return dispatch(setErrorMessage(msg.settings.flashMessage.failure));
      });
}

export function linkFacebook(fbResponse) {
  if (fbResponse && fbResponse.status !== CONNECTED) {
    return () => {};
  }

  const res = fbResponse.authResponse;
  const requestBody = {
    accessToken: res.accessToken,
    signedRequest: res.signedRequest,
    uid: res.userID,
  };
  return (dispatch, getState, { network }) =>
    network.post(`${config.apiBasePath}/settings/facebook`, {
      body: JSON.stringify(requestBody),
    })
      .then(() => {
        wa.triggerPageEvent(
          pageEventTypes.FACEBOOK_SETTINGS_SUCCESS_NOTIFICATION_DISPLAYED, { [FACEBOOK_LINKED_FIELD_NAME]: true }
        );
        dispatch(setSuccessMessage('Facebook account linked'));
        return dispatch(getFacebook());
      })
      .catch((error) => {
        if (error.data.code === 'LOGIN_PREVALIDATION_FAILED') {
          wa.triggerPageEvent(pageEventTypes.FACEBOOK_SETTINGS_ALREADY_LINKED_POPUP_DISPLAYED,
            { [FACEBOOK_LINKED_FIELD_NAME]: false });
          return dispatch(openAccountAlreadyLinkedPopup());
        }
        wa.triggerPageEvent(
          pageEventTypes.FACEBOOK_SETTINGS_ERROR_NOTIFICATION_DISPLAYED, { [FACEBOOK_LINKED_FIELD_NAME]: true }
        );
        return dispatch(setErrorMessage(msg.settings.flashMessage.failure));
      });
}
